<template>
  <div class="main">
     <div class="box">
       <!-- 会议室预定分析 -->
      <div class="img" >
          <img src="../img/mettingfenxi.png" alt="">
      </div>
      <!-- 使用率 -->
      <div class="utilization-rate">
        <img  v-if="meetingInfo.notes_tip==='00'||'01'" src="../img/frame2.png" alt="">
        <img v-else src="../img/meetingfenxi.png" alt="">
        <div class="lv">
          <div v-if="meetingInfo.notes_tip==='00'||'01'" class="uselv"> {{meetingInfo.notes_title}} </div>
          <div v-else class="uselv2"> {{meetingInfo.notes_title}} </div>
          <div class="use-thing"> {{meetingInfo.notes}} </div>
        </div>
      </div>
   
     </div>
     <!-- 预定次数-->
     <div class="boxs">
        <img src="../img/scheduledtimes.png" alt="">
        <div class="middle-num">
          <!-- <div> {{totalReservations}}   </div> -->
          <div>{{meetingTotal.by_date.buckets[28].total_reservations.value}}</div>
          <div class="line"></div>
          <font>中间值: {{meetingTotal.median_reservations.values['50.0']}} </font>
        </div>
  
     </div>
     <!-- 预定总时长 -->
     <div class="boxs">
       <img src="../img/scheduledduration.png" alt="">
         <div class="middle-num">
          <!-- <div>{{totalDuration}}</div> -->
          <div> {{meetingTotal.by_date.buckets[28].total_duration.value}} </div>
          <div class="line"></div>
          <font>中间值: {{meetingTotal.median_duration.values['50.0']}}</font>
        </div>
     </div>
     <!-- 重新使用率 -->
     <div class="boxs">
       <img src="../img/reuserate.png" alt="">
         <div class="middle-num">
           <!-- <div>{{totalAttendances}}</div> -->
           <div>{{meetingTotal.by_date.buckets[28].total_attendances.value}}</div>
          <div class="line"></div>
          <font>中间值: {{meetingTotal.median_attendances.values['50.0']}}</font>
        </div>
     </div>
  </div>
</template>

<script>
import config from "../../config";
import * as api from "../../services/api";
import dayjs from "dayjs";

export default {
// props:{
//   meetingInfo:{
//     type:Object,
//     require:true
//   },
//   meetingTotal:{
//     type:Object,
//    require:true

//   }

// },
data(){
  return{
      meetingTotal:{},
      meetingInfo:{},
  }
},
computed:{
  //  totalDuration(){
  //   return this.meetingTotal.by_date.buckets[28].total_duration.value
  // },
  //  totalReservations(){
  //   return this.meetingTotal.by_date.buckets[28].total_reservations.value
  // },
  // totalAttendances(){
  //   return this.meetingTotal.by_date.buckets[28].total_attendances.value
  // },
},
mounted(){
    this.loadMeetingStatus()
    this.loadMeetingTotals()
   setInterval(() => {
     this.loadMeetingStatus()
     this.loadMeetingTotals()
    }, 10 * 60 * 1000); // load data every 10 minut
},
created(){
 
},
methods:{
   loadMeetingStatus:async function(){
        const resp= await api.getMeetingStatus(config.locationId,{
           start_at: dayjs().subtract('1','month').format('YYYY-MM-DD'),
           end_at: dayjs().format('YYYY-MM-DD'),
        })
        this.meetingInfo = resp.data
    },
    // 会议室次数时长人数
    loadMeetingTotals:async function(){
      const resp2= await api.getMeetingTotals(config.locationId,{
           start_date: dayjs().subtract('1','month').format('YYYY-MM-DD'),
           end_date: dayjs().format('YYYY-MM-DD'),
        })
        this.meetingTotal=resp2.data.stats
    },
},
}
</script>

<style lang="less">
.main{
  display: flex;
  justify-content: space-around;
  width: 100%;
}
.box{
  width:312px;
  height: 117.27px;
  background:url(../img/bigBorder.png) no-repeat;
  background-size: 348px 153px;
  background-position: left -18px bottom -18px ;
}
.boxs{
  width:207px;
  height: 117.27px;
  background: url(../img/smallBorder.png);
  background-size: 244px 152px;
  background-position: left -18px bottom -18px ;
  /* background-size: cover; */
}
.line{
  width: 100%;
  height: 3px;
  background-color: #76FFFF;
}
.boxs img {
  margin: 5px 5px 0;
}
.middle-num{
  height: 50px;
  width: 132px;
  margin: -5px 0px 0px 22.5px;
  padding-top: -5px;
}
.middle-num > div{
  font-family: 'Furore';
  font-style: normal;
  font-weight: 400;
  font-size: 30px;
  line-height: 35px;
  color:#76FFFF;
}
.middle-num font{
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
}
.utilization-rate{
  display: flex;
  height: 57px;
  width: 282px;
  left: 17px;
  top: 48px;
  border-radius: 0px;
  margin-top: -15px;

}
.utilization-rate > img{
  height:100px;
  width:100px;
  margin-top: -10px;
}
.use-thing{
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
}
.uselv{
  font-size: 16px;
  color:#FBE947;
  font-weight: 900;
  font-family: 'Alibaba PuHuiTi';
}
.uselv2{
  font-size: 16px;
  color:#7CFF70;
  font-weight: 900;
  font-family: 'Alibaba PuHuiTi';
}
.lv{
  margin-top: 10px;
}
.img{
  padding: 5px 5px 0;

}
</style>
